import { NgIf } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
  ViewEncapsulation
} from '@angular/core';
import { Router } from '@angular/router';
import { ScreenSizeService } from '@Shared/services';
import { UserCommonApiService } from '@App/common/services';

@Component({
  selector: 'app-ep-restrict',
  templateUrl: './ep-restrict.component.html',
  styleUrls: ['./ep-restrict.component.scss'],
  standalone: true,
  imports: [NgIf],
  encapsulation: ViewEncapsulation.None
})
export class EpRestrictComponent implements OnInit {
  isAuthUser: boolean = false;

  @Output() submitClick: EventEmitter<any> = new EventEmitter();

  @Input() isShowBlur = false;

  @Input() isShowRestrict = false;

  @Input() scale = 1.0;

  constructor(
    private router: Router,
    private screenSizeService: ScreenSizeService,
    private userService: UserCommonApiService
  ) {}

  @HostBinding('style.--scale-factor')
  get scaleFactor() {
    return this.scale;
  }

  ngOnInit(): void {
    this.setScaleOnMobile();
    this.isAuthUser = this.userService.isAuthenticated();
  }

  showContactMeDialog() {
    this.submitClick.emit();
  }

  goToPrice() {
    this.router.navigate(['pricing']);
  }

  setScaleOnMobile() {
    if (this.screenSizeService.isMobile) {
      this.scale = null;
    }
  }
}
